@import 'apps/webcomponents/src/assets/common.scss';

gz-labeled-content {
  height: auto;

  .details-panel-endpoint-link {
    margin-left: calc(var(--spacer) / -6);
  }

  gz-link {
    --wrapper-padding: 0;
  }
}

table {
  width: 100%;
  display: inline-block;
}

.details-panel-wrapper {
  padding: var(--spacer);
  height: 100%;

  .details-panel {
    padding: calc(2 * var(--spacer));
    height: 100%;
    display: flex;
    flex-direction: column;

    .details-panel-header {
      margin-bottom: calc(3 * var(--spacer));
      color: var(--body-text-arrows-400);
    }

    .details-panel-section {
      padding-top: var(--spacer);
      height: inherit;
      width: 100%;
      border-top: 1px solid var(--chart-101-pressed-dividers);
      display: flex;
      flex-direction: column;

      .details-panel-content-title {
        text-transform: uppercase;
        margin-bottom: var(--spacer);
      }
    }

    .details-panel-first-section {
      border-top: none;
    }

    gz-labeled-content::part(content) {
      font-size: var(--body-size);
    }

    gz-copy-to-clipboard::part(container),
    gz-labeled-content::part(container) {
      align-items: center;
    }

    .text-ellipsis-content,
    gz-link::part(container) {
      display: inline-block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    gz-link {
      max-width: calc(100% + var(--spacer));
      &::part(container) {
        vertical-align: middle;
      }
    }

    gz-labeled-content[clampLine] {
      gz-copy-to-clipboard::part(button) {
        align-self: baseline;
      }

      .text-ellipsis-content {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
      }
    }
  }
}

gz-table::part(table-row) {
  border-bottom: none;
}

gz-table::part(table-row-icon) {
  display: block;
  text-align: center;
  color: var(--chart-300-icon-buttons);
}

gz-table::part(cell-value) {
  font-weight: 400;
  color: var(--main-titles-inputs-600);
}
